import { render, staticRenderFns } from "./PostingModal.vue?vue&type=template&id=5cad5fae"
import script from "./PostingModal.vue?vue&type=script&lang=ts"
export * from "./PostingModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cad5fae')) {
      api.createRecord('5cad5fae', component.options)
    } else {
      api.reload('5cad5fae', component.options)
    }
    module.hot.accept("./PostingModal.vue?vue&type=template&id=5cad5fae", function () {
      api.rerender('5cad5fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/postings/PostingModal.vue"
export default component.exports